<template>
  <div :class="['ph-app__container', suitId]">
    <img
      v-if="creativeData['bg_url']"
      class="ph-app__background"
      :src="creativeData['bg_url']"
    />
    <img
      v-if="creativeData['bg_url']"
      class="ph-app__perview"
      :src="creativeData['preview_url']"
    />
    <div
      v-if="!creativeData['bg_url']"
      class="ph-app__perview skeleton"
    />
    <ph-dialog
      title="取消后将失去此主题佩戴"
      :show.sync="show"
      :showCancelButton="true"
      @confirm="onSure"
      @cancel="onCancel"
    />
    <ph-dialog
      title="暂不支持佩戴此商业装扮"
      content="由于您是微博影响力用户，暂不支持佩戴此商业装扮，感谢您的支持。"
      :show.sync="showBlackListDialog"
      :showCancelButton="false"
      @confirm="closePage"
    />
    <ph-button
      class="ph-app__action"
      v-if="!creativeData.wore && isDelivery"
      :disabled="iLoading"
      type="primary"
      size="large"
      @click="putOn"
    >
      一键佩戴
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="creativeData.wore && isDelivery"
      :disabled="iLoading"
      type="primary"
      size="large"
      @click="showDialog"
    >
      取消佩戴
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="!isDelivery"
      :disabled="true"
      type="primary"
      size="large"
    >
      {{statusText}}
    </ph-button>
    <div
      v-if="isNotStart"
      class="ph-app__time"
    >
      活动将于{{startTime}}开始
    </div>
    <ph-checkbox
      v-if="showAgreement"
      v-model="agreement"
      class="ph-app__checkbox"
    >
      同步到微博
    </ph-checkbox>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import userService from '@services/user';
import toast from '@components/toast';
import PhCheckbox from '@components/checkbox';
import PhDialog from '@components/dialog';
import PhButton from '@components/button';
import {cheka, CHEKA_EVENTS} from '@utils/cheka';
import {REVERSE_API_STATUS_MAP} from '@data/apiStatusMap';
import jsBridge from '@utils/jsbridge';
import {getUrlParam} from '@utils/url';
import { DELIVERY_STATUS } from '@data/deliveryStatus';

import '@styles/index';

export default {
  name: 'App',
  components: {
    PhDialog,
    PhButton,
    PhCheckbox
  },
  props: {},
  computed: {
    statusText() {
      return this.isNotStart? '活动未开启': '活动已结束';
    },
    startTime() {
      return dayjs.unix(this.creativeData['start_time']).format('YYYY[年]MM[月]DD[日]HH[时]mm[分]ss[秒]');
    },
    isNotStart() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.NOT_START.id;
    },
    isOver() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.OVER.id;
    },
    isDelivery() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.DELIVERY.id;
    },
    showAgreement() {
      return this.creativeData &&
          this.isDelivery &&
          !this.creativeData.wore &&
          !this.iLoading;
    }
  },
  data() {
    return {
      show: false,
      iLoading: false,
      showBlackListDialog: false,
      creativeData: {},
      agreement: true,
      suitId: '',
      isError: false
    };
  },
  mounted() {
    this.suitId = getUrlParam('suit_id').toUpperCase();
    userService.login()
      .then(() => {
        this.init();
      })
      .catch(() => {
        this.isError = true;
      });
  },
  methods: {
    init() {
      cheka('send', {eventid: CHEKA_EVENTS.PAGE_INIT.id});
      this.creativeData = userService.getUserInfo();
      if (this.creativeData['on_the_list']) {
        this.showBlackListDialog = true;
      }
      document.title = this.creativeData['title'];
    },
    showDialog() {
      if (!this.creativeData.wore) {
        this.onSure();
      } else {
        this.show = !this.show;
        this.iLoading = true;
      }
    },
    putOn() {
      this.iLoading = true;
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventvalue: {
          'action_type': 'before_put_on',
          uid: this.creativeData['uid'],
          suitId: this.suitId
        }
      });

      userService.putOn({
        is_feed: this.agreement ? 1 : 0,
      }).then(() => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
          eventvalue: {
            'action_type': 'after_put_on',
            uid: this.creativeData['uid'],
            suitId: this.suitId
          }
        });
        this.$set(this.creativeData, 'wore', true);
        this.goback();
        toast({
          content: '装扮成功',
          type: 'success'
        });
      }).catch((error) => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_FAILD.id,
          eventvalue: {
            'action_type': 'after_put_on',
            uid: this.creativeData['uid'],
            suitId: this.suitId
          }
        });
        toast({
          content: error.data.message,
          type: 'success'
        });
        this.reload(error.data);
      }).finally(() => {
        this.iLoading = false;
      });
    },
    onCancel() {
      cheka('send', {eventid: CHEKA_EVENTS.ACTION_CANCEL.id});
      this.iLoading = false;
    },
    onSure() {
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventvalue: {
          'action_type': 'before_take_off',
          uid: this.creativeData['uid'],
          suitId: this.suitId
        }
      });
      userService.takeOff().then(() => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
          eventvalue: {
            'action_type': 'after_take_off',
            uid: this.creativeData['uid'],
            suitId: this.suitId
          }
        });
        this.$set(this.creativeData, 'wore', false);
        this.goback();
        toast({
          content: '取消成功',
          type: 'success'
        });
      }).catch((error) => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_FAILD.id,
          eventvalue: {
            'action_type': 'after_take_off',
            uid: this.creativeData['uid'],
            suitId: this.suitId
          }
        });
        toast({
          content: error.data.message,
          type: 'success'
        });
        this.reload(error.data);
      }).finally(() => {
        this.iLoading = false;
      });
    },
    reload(data) {
      if (data && data.code && String(data.code) === String(REVERSE_API_STATUS_MAP.REPEAT_OPERATION)) {
        const timer = setTimeout(() => {
          clearTimeout(timer);
          window.location.reload();
        }, 2500);
      }
    },
    closePage() {
      window.location.href = 'sinaweibo://browser/close';
    },
    goback() {
      const timer = setTimeout(() => {
        clearTimeout(timer);
        jsBridge('invoke', 'sendWboxBroadcast', {
          key: 'com.weibo.wbox.set_pageskin_notice',
          data: {
            uid: this.creativeData.uid
          }
        }, function() {});
        const channel = getUrlParam('channel');
        if(channel && channel !== 'groupSkin') {
          window.location.href = `sinaweibo://userinfo?uid=${this.creativeData.uid}&fid=profile_me`;
        }
      }, 1000);
    }
  }
}
</script>
